/**
 * Accounting state codes used across the per-shipment Accounting tab. Kept in sync
 * with `sideEffects/shipments/settings/mockData.tsx` so the BP-level Accounting tab
 * can render the same labels / colors without depending on shipment settings state.
 */
export type AccountingStateEntry = {
    code: string;
    name: string;
    color: string;
    displayOrder: number;
};

export const ACCOUNTING_STATE_CATALOG: ReadonlyArray<AccountingStateEntry> = [
    { code: 'WATING_PRICING', name: 'Waiting for 3rd party pricing', color: '#c1292e', displayOrder: 0 },
    { code: 'NO_INTERNAL_PRICING', name: 'No Pricing Internal', color: '#c1292e', displayOrder: 1 },
    { code: 'WATING_OPERATOR', name: 'Waiting for operator billing', color: '#f4c915', displayOrder: 2 },
    { code: 'WAITING_ORDER_NUMBER', name: 'Waiting for order # / order details', color: '#f4c915', displayOrder: 3 },
    { code: 'READY_FOR_CHARGE', name: 'Ready for freight charge - waiting for T&D charges', color: '#00B5B9', displayOrder: 4 },
    { code: 'READY_TO_ISSUE', name: 'Ready to issue', color: '#639e31', displayOrder: 5 },
    { code: 'INVOICE_SENT', name: 'Invoice sent', color: '#2e7d32', displayOrder: 6 },
    { code: 'INVOICE_PAID', name: 'Invoice paid', color: '#1b5e20', displayOrder: 7 }
];

const CODE_LOOKUP: ReadonlyMap<string, AccountingStateEntry> = new Map(
    ACCOUNTING_STATE_CATALOG.map((s) => [s.code, s])
);

export function lookupAccountingState(code: string | null | undefined): AccountingStateEntry | null {
    if (!code) return null;
    return CODE_LOOKUP.get(code) ?? null;
}
